import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CommonService } from '../../service/common.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {

  constructor(private router:Router, private common: CommonService){

  }

  gotoUrls(ele:string){
    this.router.navigateByUrl(ele);
  }

  gotoLinksCategory(data: any) {
    if (data == 'B2B') {
      this.router.navigate(['/b2b']);
    } 
    else if (data == 'Construction' || data == 'Interior' || data == 'Apparel & Garments') {
      const seoCategory = this.common.createSlugUrl(data);
      this.router.navigate(['/service', seoCategory])
        .then(() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }));
    } else if (data == 'Cars') {
      window.open('https://btechcars.com/', '_blank');
    } else if (data == 'Medicine') {
      window.open('https://www.bpharmastore.com/', '_blank');
    } else if (data == 'Real State') {
      window.open('https://property.btechmart.in/', '_blank');
    }
  }
}
